import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-stone-50" id="categories">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            探索<span className="text-orange-500">在线撸</span>的六大板块
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            六大分类，总有你喜欢的在线撸方式
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="h-44 md:h-48 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-orange-500/90 text-white">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  <h3 className="text-white font-bold text-lg">{cat.name}</h3>
                </div>
                <p className="text-white/70 text-xs mt-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}